module.exports = __webpack_public_path__ + "static/media/bg-mobile3.3ed89f88.png";